function getHref() {
  return window.location.href;
}

const Location = {
  getHref,
};

export default Location;
